/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { Chip } from '@material-ui/core';
import Cancel from '../../public/icons/cross-chip.svg';

type LimitTagsProps = {
  opportunityLabelsList: {[key:string]: any}[];
  checkedLabels: number[];
  handleCheckboxChange: (labels: number[]) => void;
};

const LimitTags = (props: LimitTagsProps) => {
  const { opportunityLabelsList, checkedLabels, handleCheckboxChange } = props;

  const handleOptionClick = (id: number) => {
    const newCheckedLabels = checkedLabels.includes(id)
      ? checkedLabels.filter((item) => item !== id)
      : [...checkedLabels, id];
    handleCheckboxChange(newCheckedLabels);
  };

  const handleDeleteChip = (id: number) => {
    handleCheckboxChange(checkedLabels.filter((item) => item !== id));
  };

  return (
    <div>
      <div className="flex flex-wrap gap-2 mb-2">
        {checkedLabels.length === 0 ? (
          <span className="flex-1 text-gray-500">--Select--</span>
        ) : (
          checkedLabels.map((id, index) => (
            <Chip
              key={index}
              label={opportunityLabelsList?.find(itm => itm.id === id)?.name}
              onDelete={() => handleDeleteChip(id)}
              deleteIcon={<Cancel style={{ cursor: 'pointer'}} />}
              style={{
                backgroundColor: '#E1EBEF',
                borderRadius: '8px',
                color: '#1C1D21',
                fontWeight: 500,
              }}
            />
          ))
        )}
      </div>
      {opportunityLabelsList && opportunityLabelsList.map((itm, idx) => (
        <div
          key={idx}
          className="flex justify-start py-2 cursor-pointer"
          onClick={() => {
            handleOptionClick(itm?.id);
          }}
        >
          <input
            type="checkbox"
            checked={checkedLabels.includes(itm?.id)}
            className="form-checkbox h-3.5 w-3.5 lg:h-4 lg:w-4 text-secondary focus:ring-transparent cursor-pointer rounded-sm border-secondary"
            name={itm?.name}
            value={itm?.name}
            id={itm?.name}
            onChange={() => handleOptionClick(itm?.id)}
          />
          <h4 className="text-primary-dark text-xs lg:text-sm font-medium leading-4 mx-2">
            {itm?.name}
          </h4>
        </div>
      ))}
    </div>
  );
};

export default LimitTags;











